import axios from '@/libs/api.request'

export const getMachinesByActivity = (data) => {
  return axios.request({
    url: '/print/machine/activity/id',
    params: data,
    method: 'get'
  })
}
export const unBindMachine = (data) => {
  return axios.request({
    url: '/print/machine/activity/unbind',
    data: data,
    method: 'put'
  })
}
export const bindMachine = (data) => {
  return axios.request({
    url: '/print/machine/activity/bind',
    data: data,
    method: 'put'
  })
}
export const saveMachineActivity = (data) => {
  return axios.request({
    url: '/print/machine/activity',
    data: data,
    method: 'put'
  })
}
export const getMachineActivity = (data) => {
  return axios.request({
    url: '/print/machine/activity',
    params: data,
    method: 'get'
  })
}
export const getMachineType = (data) => {
  return axios.request({
    url: '/print/machine/type',
    params: data,
    method: 'get'
  })
}
export const insertMachineType = (data) => {
  return axios.request({
    url: '/print/machine/type/insert',
    data,
    method: 'put'
  })
}
export const updateMachineType = (data) => {
  return axios.request({
    url: '/print/machine/type/update',
    data,
    method: 'put'
  })
}
export const machineSave = (data) => {
  return axios.request({
    url: '/print/machine',
    data,
    method: 'put'
  })
}
export const machineGet = data => {
  return axios.request({
    url: '/print/machine',
    params: data,
    method: 'get'
  })
}
export const machineInfo = data => {
  return axios.request({
    url: '/print/machine/info',
    params: data,
    method: 'get'
  })
}
export const DelType = data => {
  return axios.request({
    url: '/print/machine/type/del',
    data,
    method: 'put'
  })
}
export const MachineDispense = data => {
  return axios.request({
    url: '/print/machine/dispense',
    params: data,
    method: 'get'
  })
}
export const SaveDispense = data => {
  return axios.request({
    url: '/print/machine/dispense',
    data,
    method: 'put'
  })
}
export const MachineError = data => {
  return axios.request({
    url: '/print/machine/error/info',
    params: data,
    method: 'get'
  })
}
export const MachineErrorList = data => {
  return axios.request({
    url: '/print/machine/error',
    params: data,
    method: 'get'
  })
}
export const MachineErrorDel = data => {
  return axios.request({
    url: '/print/machine/error_del',
    data,
    method: 'post'
  })
}
export const MachineErrorStatus = data => {
  return axios.request({
    url: '/print/machine/error_status',
    data,
    method: 'post'
  })
}
export const GetMachinesByScreenSaver = data => {
  return axios.request({
    url: '/print/machine/screen',
    params: data,
    method: 'get'
  })
}
export const GetMachineConnect = data => {
  return axios.request({
    url: '/print/machine/connect',
    params: data,
    method: 'get'
  })
}
export const SetMachineDate = data => {
  return axios.request({
    url: '/print/machine/renew',
    data,
    method: 'post'
  })
}
export const GetMachineRenew = data => {
  return axios.request({
    url: '/print/machine/renew',
    params: data,
    method: 'get'
  })
}
export const GetMachineReport = data => {
  return axios.request({
    url: '/print/machine/GetMachineReport',
    params: data,
    method: 'get'
  })
}
export const GetMachineTrack = data => {
  return axios.request({
    url: '/print/machine/MachineTrack',
    params: data,
    method: 'get'
  })
}
export const SaveMachineTrack = data => {
  return axios.request({
    url: '/print/machine/MachineTrack',
    data,
    method: 'post'
  })
}
export const SaveMachineLog = data => {
  return axios.request({
    url: '/print/machine/logs',
    data,
    method: 'post'
  })
}
export const GetMachineLogList = data => {
  return axios.request({
    url: '/print/machine/logs',
    params: data,
    method: 'get'
  })
}
export const MachineListConcise = data => {
  return axios.request({
    url: '/print/MachineListConcise',
    params: data,
    method: 'get'
  })
}
export const GetMachineRepair = data => {
  return axios.request({
    url: 'print/machine/GetMachineRepair',
    params: data,
    method: 'get'
  })
}

export const GetMachineDispense = data => {
  return axios.request({
    url: 'print/machine/GetMachineDispense',
    params: data,
    method: 'get'
  })
}
export const GetAgentDispenseAccount = data => {
  return axios.request({
    url: 'print/machine/GetAgentDispenseAccount',
    params: data,
    method: 'get'
  })
}

export const SaveMachineDispense = data => {
  return axios.request({
    url: 'print/machine/SaveMachineDispense',
    data,
    method: 'post'
  })
}
export const SyncMachine = data => {
  return axios.request({
    url: 'print/SyncMachine',
    data,
    method: 'post'
  })
}

export const GetMachineLastError = data => {
  return axios.request({
    url: 'print/machine/GetMachineLastError',
    params: data,
    method: 'get'
  })
}


export const GetMachineTypeGroup = data => {
  return axios.request({
    url: 'print/machine/type_group',
    params: data,
    method: 'get'
  })
}

